export const stickyLeft = {
  position: 'sticky',
  left: 0,
  // boxShadow: "1px 5px 3px grey",
  zIndex: 5,
  backgroundColor: 'white'
};
export const stickyShadowLeft = "6px 0px 5px -1px rgba(0, 0, 0, 0.02)";
export const stickyShadowRight = ""; //"-6px 0px 5px -1px rgba(0, 0, 0, 0.02)";

export const generateStickyLeft = function () {
  let left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    position: 'sticky',
    zIndex: 5,
    left
  };
};
export const stickyRight = {
  zIndex: 6,
  position: 'sticky',
  right: 0,
  backgroundColor: 'inherit'
};
export const generateStickyRight = function () {
  let right = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    zIndex: 6,
    position: 'sticky',
    backgroundColor: 'inherit',
    right
  };
};
export const CHECKBOX_CELL_WIDTH = 64;
export const COLLAPSE_CELL_WIDTH = 50;